import {Component} from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import {inputPlaceholder, lighten, rem, size} from '-/styles/utils';

const styles = theme => ({
    root: {
        margin: `0 ${rem(30)}`,
        overflow: 'hidden',
        '& input[type=\'radio\']': {
            marginLeft: 10
        },
        '& input[type=\'text\'], & input[type=\'tel\'], & input[type=\'email\'], & textarea': {
            ...size('100%', '47px'),
            minHeight: 47,
            padding: `0 ${rem(18)}`,
            border: 'none',
            borderLeft: '1px solid gainsboro',
            borderRight: '1px solid gainsboro',
            fontFamily: theme.fontFamily,
            fontSize: rem(14),
            fontWeight: 'normal',
            lineHeight: rem(47),
            color: '#000',
            outline: 0,
            opacity: .8,
            backgroundColor: 'white',

            '&:active, &:focus': {
                border: '1px solid #4a90e2',
                boxShadow: '0 0 2px rgba(73, 143, 225, 0.7)'
            },
            ...inputPlaceholder({
                fontFamily: theme.fontFamily,
                fontSize: rem(14),
                fontWeight: 'normal',
                color: lighten('#ccc', .1)
            }),
            '&:read-only': {
                background: lighten('#ccc', .1)
            }
        }
    },
    standalone: {
        marginTop: rem(30)
    }
});

class Form extends Component {
    render() {
        const {standalone = false, className = '', theme, classes = {}, children, ...rest} = this.props;

        const cls = classNames(classes.root, className, {
            [classes.standalone]: standalone
        });

        return (
            <form className={cls} {...rest}>{children}</form>
        );
    }
}

export default injectSheet(styles)(Form);
